export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-google-plus-7a4b42b4d0153d0a5521590cc1b0951b.svg";